import Vue from 'vue';
import { AnalysesSearchService } from '../services/AnalysesSearchService';
import { KitapoService } from '../services/KitapoService';
import { types as userTypes } from './user';
import { createNewId } from '../firebase/firestore';
import COLORS from '../constants/colors';

const MODULE_PREFIX = 'analysesCapture';
const GETTER_ANALYSIS_CAPTURE_IN_PROGRESS = 'analysisCaptureInProgress';
const GETTER_ANALYSIS_WITH_CONTENT_URL = 'analysesWithContentUrl';
const GETTER_PREPARED_ANALYSIS = 'preparedAnalysis';
const GETTER_ON_PREPARED_ANALYSIS = 'onPreparedAnalysis';
const ACTION_PREPARE_ANALYSIS = 'prepareAnalysis';
const ACTION_SAVE_PREPARED_ANALYSIS = 'savePreparedAnalysis';
const ACTION_RESET_PREPARED_ANALYSIS = 'resetPreparedAnalysis';
const ACTION_FETCH_ANALYSES_BY_URL = 'fetchAnalysesByUrl';
const MUTATION_START_ANALYSIS_CAPTURE = 'START_ANALYSIS_CAPTURE';
const MUTATION_ANALYSIS_CAPTURE_FINISHED = 'ANALYSIS_CAPTURE_FINISHED';
const MUTATION_ANALYSIS_WITH_CONTENT_URL = 'ANALYSIS_WITH_CONTENT_URL';
const MUTATION_UPDATE_PREPARED_ANALYSIS = 'MUTATION_UPDATE_PREPARED_ANALYSIS';
const MUTATION_ON_PREPARED_ANALYSIS = 'MUTATION_ON_PREPARED_ANALYSIS';
const MUTATION_RESET_PREPARED_ANALYSIS = 'MUTATION_RESET_PREPARED_ANALYSIS';

const initialState = {
  analysesWithContentUrl: [],
  analysisCaptureInProgress: {
    value: false,
  },
  preparedAnalysis: {},
  onPreparedAnalysis: false,
};

const analysesSearchService = new AnalysesSearchService();

const actions = {
  [ACTION_PREPARE_ANALYSIS]: async ({ commit, rootGetters }, documentDetails) => {
    // TODO update Home.vue for to put documentDetails in an object
    const userDetails = rootGetters[userTypes.getters.userDetails];
    const analysisId = createNewId();
    const documentId = documentDetails.documentId && documentDetails.documentId !== ''
      ? documentDetails.documentId
      : createNewId();
    const analysis = {
      acl: [
        {
          entityId: userDetails.userId,
          permission: 'Owner',
          entityType: 'User',
          displayName: userDetails.displayName,
        },
      ],
      createdBy: userDetails.userId,
      tags: [],
      id: analysisId,
      documentId,
      documentDetails: {
        ...documentDetails,
        sourceId: documentDetails.sourceId || `user/${userDetails.userId}`,
      },
    };

    await commit(MUTATION_ON_PREPARED_ANALYSIS, true);
    await commit(MUTATION_UPDATE_PREPARED_ANALYSIS, analysis);
  },
  [ACTION_RESET_PREPARED_ANALYSIS]: async ({ commit }) => {
    commit(MUTATION_RESET_PREPARED_ANALYSIS);
  },
  [ACTION_SAVE_PREPARED_ANALYSIS]: async ({ commit, state, dispatch }, analysisModification) => {
    commit(MUTATION_START_ANALYSIS_CAPTURE);
    const analysis = Object.assign({}, state.preparedAnalysis, analysisModification);

    const portfolioIds = analysis.acl.map(acl => acl.entityId);
    console.log('----->>>>> savePreparedAnalysis : ', analysis);

    const service = new KitapoService();

    try {
      await service.saveAnalysisV2(portfolioIds, analysis);
      commit(MUTATION_ON_PREPARED_ANALYSIS, false);

      dispatch('handleOperationCompletion', {
        message: 'captureDocument.analysisCreated',
        color: COLORS.green,
        closeExtensionOnHide: false,
      }, { root: true });
    } catch (error) {
      dispatch('handleOperationCompletion', {
        message: 'captureDocument.analysisCreationFailed',
        color: COLORS.red,
        closeExtensionOnHide: false,
      }, { root: true });
      throw error;
    } finally {
      commit(MUTATION_ANALYSIS_CAPTURE_FINISHED);
    }
  },
  [ACTION_FETCH_ANALYSES_BY_URL]: async ({ commit }, url) => {
    console.log('ACTION_FETCH_ANALYSES_BY_URL', url);
    const analyses = await analysesSearchService.searchByUrl(url);
    commit(MUTATION_ANALYSIS_WITH_CONTENT_URL, analyses);
  },
};

const mutations = {
  [MUTATION_START_ANALYSIS_CAPTURE]: (state) => {
    Vue.set(state, 'analysisCaptureInProgress', { value: true });
  },
  [MUTATION_ANALYSIS_CAPTURE_FINISHED]: (state) => {
    Vue.set(state, 'analysisCaptureInProgress', { value: false });
  },
  [MUTATION_ANALYSIS_WITH_CONTENT_URL]: (state, analyses) => {
    Vue.set(state, 'analysesWithContentUrl', analyses);
  },
  [MUTATION_UPDATE_PREPARED_ANALYSIS]: (state, analysis) => {
    Vue.set(state, 'preparedAnalysis', analysis);
  },
  [MUTATION_ON_PREPARED_ANALYSIS]: (state, value) => {
    Vue.set(state, 'onPreparedAnalysis', value);
  },
  [MUTATION_RESET_PREPARED_ANALYSIS]: (state) => {
    Vue.set(state, 'onPreparedAnalysis', false);
  },
};

const getters = {
  [GETTER_ANALYSIS_CAPTURE_IN_PROGRESS]: state => state.analysisCaptureInProgress,
  [GETTER_ANALYSIS_WITH_CONTENT_URL]: state => state.analysesWithContentUrl,
  [GETTER_PREPARED_ANALYSIS]: state => state.preparedAnalysis,
  [GETTER_ON_PREPARED_ANALYSIS]: state => state.onPreparedAnalysis,
};

export default {
  namespaced: true, state: initialState, getters, mutations, actions,
};

export const types = {
  getters: {
    analysisCaptureInProgress: `${MODULE_PREFIX}/${GETTER_ANALYSIS_CAPTURE_IN_PROGRESS}`,
    analysesWithContentUrl: `${MODULE_PREFIX}/${GETTER_ANALYSIS_WITH_CONTENT_URL}`,
    preparedAnalysis: `${MODULE_PREFIX}/${GETTER_PREPARED_ANALYSIS}`,
    onPreparedAnalysis: `${MODULE_PREFIX}/${GETTER_ON_PREPARED_ANALYSIS}`,
  },
  mutations: {
    START_ANALYSIS_CAPTURE: `${MODULE_PREFIX}/${MUTATION_START_ANALYSIS_CAPTURE}`,
    ANALYSIS_CAPTURE_FINISHED: `${MODULE_PREFIX}/${MUTATION_ANALYSIS_CAPTURE_FINISHED}`,
    ANALYSIS_WITH_CONTENT_URL: `${MODULE_PREFIX}/${MUTATION_ANALYSIS_WITH_CONTENT_URL}`,
  },
  actions: {
    fetchAnalysesByUrl: `${MODULE_PREFIX}/${ACTION_FETCH_ANALYSES_BY_URL}`,
    prepareAnalysis: `${MODULE_PREFIX}/${ACTION_PREPARE_ANALYSIS}`,
    savePreparedAnalysis: `${MODULE_PREFIX}/${ACTION_SAVE_PREPARED_ANALYSIS}`,
    resetPreparedAnalysis: `${MODULE_PREFIX}/${ACTION_RESET_PREPARED_ANALYSIS}`,
  },
};
